// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.bundle';
// import '../assets/css/style.css';
// import '../assets/js/main';
import { Link, useLocation } from "react-router-dom";

function Breadcrumbs(props) {
  const location = useLocation();
  const currentPath = location.pathname;
  const isHomePage = currentPath === "/";
  const isServicePage = ["/international", "/consults", "/investment", "/communication"].includes(currentPath);

  return (
    <section className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <h2>{props.page}</h2>
          <ol>
            <li className={isHomePage ? "active" : ""}>
              <Link to="/" className={isHomePage ? "active" : ""}>Home</Link>
            </li>
            <li className={isServicePage ? "active" : ""}>Services</li>
            <li className={!isHomePage ? "active" : ""}>{props.page}</li>
          </ol>
        </div>
      </div>
    </section>
  );
}

export default Breadcrumbs;
